
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/francais",
      function () {
        return require("private-next-pages/francais.tsx");
      }
    ]);
  